/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import {
  FETCH_GLOBAL_ADMIN_FLEX_METADATA_REQUEST,
  FETCH_GLOBAL_ADMIN_FLEX_METADATA_SUCCESS,
  FETCH_GLOBAL_ADMIN_FLEX_METADATA_FAILURE,
  SET_GLOBAL_FLEX_METADATA_CHIP_LIST,
  SET_SUBMISSION_API_DATA,
  SET_SUBMISSION_FLEX_METADATA_IDS,
} from "./GlobalAdminFlexTypes";

const initialState = {
  loading: false,
  flexMetadata: [],
  globalFlexMetaDataChipList: [],
  submissionAPIdata: {},
  flexMetadataIds: [],
  error: "",
};

const GlobalAdminFlexReducers = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_GLOBAL_ADMIN_FLEX_METADATA_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_GLOBAL_ADMIN_FLEX_METADATA_SUCCESS:
      return {
        ...state,
        loading: false,
        flexMetadata: action.payload,
        error: "",
      };
    case FETCH_GLOBAL_ADMIN_FLEX_METADATA_FAILURE:
      return {
        ...state,
        loading: false,
        flexMetadata: [],
        error: action.payload,
      };
    case SET_GLOBAL_FLEX_METADATA_CHIP_LIST:
      return {
        ...state,
        globalFlexMetaDataChipList: Array.isArray(action.payload)
          ? action.payload
          : [],
      };
    case SET_SUBMISSION_API_DATA:
      return {
        ...state,
        submissionAPIdata: action.payload,
      };
    case SET_SUBMISSION_FLEX_METADATA_IDS:
      return {
        ...state,
        flexMetadataIds: Array.isArray(action.payload) ? action.payload : [],
      };
    default:
      return state;
  }
};

export default GlobalAdminFlexReducers;
